import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log("Flash controller connected")
    this.dismiss()
  }

  dismiss() {
    setTimeout(() => {
      // First fade out
      this.element.classList.remove('show')
      // Then remove after fade animation completes
      setTimeout(() => {
        this.element.remove()
      }, 150) // 150ms matches Bootstrap's fade transition
    }, 5000) // 5 second delay before starting fade
  }
}